import React, { ComponentType, ReactNode } from 'react'
import CalendarInShape from '@shared/svg/in-shape/calendar.svg'
import ClockInShape from '@shared/svg/in-shape/clock.svg'
import DiagramInShape from '@shared/svg/in-shape/diagram.svg'
import clsx from 'clsx'

import styles from './style.module.scss'

export interface CreditRepaymentDataType {
	IconSvg: ComponentType<any>
	title: string
	text: ReactNode
	titleClassName?: string
}

interface Props {
	title?: string
	subTitle?: ReactNode | null
	data?: CreditRepaymentDataType[]
}

const defaultData: CreditRepaymentDataType[] = [
	{
		IconSvg: DiagramInShape,
		title: 'Погашение по графику',
		text: 'Сканируйте QR-код в мобильном приложении своего банка и вносите нужную сумму без заполнения реквизитов.',
	},
	{
		IconSvg: ClockInShape,
		title: 'Частично-досрочное погашение',
		text: 'Раз в месяц вы можете вносить больше денег, чтобы погасить задолженность быстрее.',
	},
	{
		IconSvg: CalendarInShape,
		title: 'Полное досрочное погашение',
		text: 'Погасить кредит можно в любое время. После закрытия долга отправим справку о полном погашении долга удобным вам способом.',
	},
]

const defaultSubTitle = () => (
	<div className={clsx(styles.subTitle, 'mt-m')}>
		<h3>Вносите деньги через мобильное приложение банка или кассу кредитной организации</h3>
	</div>
)

export const CreditRepaymentMethods = ({
	title = 'Способы погашения',
	subTitle = defaultSubTitle(),
	data,
}: Props) => {
	return (
		<div className='mt-l'>
			<h2>{title}</h2>
			<>{subTitle}</>
			<div className={styles.methods}>
				{(data || defaultData).map(({ IconSvg, text, title, titleClassName }) => (
					<div className={styles.method} key={title}>
						<div className={styles.methodIcon}>
							<IconSvg />
						</div>
						<div>
							<h3 className={titleClassName}>{title}</h3>
							<div className='mt-xs'>{text}</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
